import React from 'react';
import {Modal} from "antd";
import {injectIntl} from "react-intl";
import SADropdown from "../../common/dropdown/SADropdown";

class OtherSolution extends React.Component {

  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mobility) {
      this.setState({mobility: nextProps.mobility});
    }
  }

  onMobilityChange = (e) => {
    this.setState({mobility: e.target.value})
  };

  onMobilityValidate = () => {
    const {mobility} = this.state;
    this.props.onChange(mobility);
  };

  render() {
    const {intl: {locale, formatMessage}, availableMobilities, visible, onModalClose} = this.props;
    const {mobility} = this.state;
    
    const choices = availableMobilities.map(m => ({value: m.name, display: m.label ? m.label[locale] : formatMessage({id: `mobility.${m.name}`})}));
    return (
      <Modal title={formatMessage({id: 'appointment.detail.mobility.mobility-solution.title'})} visible={visible}
             onCancel={onModalClose} onOk={this.onMobilityValidate}>
        <SADropdown value={mobility} choices={choices} onChange={this.onMobilityChange}/>
      </Modal>
    )
  }
}

export default injectIntl(OtherSolution);





// WEBPACK FOOTER //
// ./src/components/interventiondetail/mobility/OtherSolution.js